:host,
:host *,
:host *::after,
:host *::before {
  box-sizing: border-box;
}

#button {
  min-height: 48px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  position: relative;
}

#button:hover #label,
#button:hover ::slotted(*) {
  color: var(--grid-action-text-button-primary-hover) !important;
}

::slotted(a)::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

#label {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

#label,
::slotted(*) {
  color: var(--grid-action-text-button-primary) !important;
  font: var(--text-link-underline) !important;
  text-decoration: underline;
}

.icon {
  width: 24px;
  height: 24px;
  display: block;
}

.icon svg {
  width: 24px;
  height: 24px;
}

.icon svg * {
  fill: var(--grid-action-text-button-primary);
}

#button:hover .icon svg * {
  fill: var(--grid-action-text-button-primary-hover);
}
